<template>
  <v-app full-height>
    <AppHeader />
    <BaseMain class="error-page d-flex flex-column align-center justify-center text-center">
      <div class="error-page__content d-flex flex-column align-center justify-center text-center">
        <v-img
          alt="ошибка"
          class="flex-grow-0"
          aria-hidden="true"
          :src="content.img"
          :height="content.imgSize"
          :width="content.imgSize"
        />
        <div class="text-h5 mt-4 px-2">
          {{ content.title }}
        </div>
        <div class="text-body-1 text-ui-kit-text-secondary px-2 mt-4">
          {{ content.subtitle }}
        </div>

        <BaseMtButton
          class="mt-6"
          text="На главную"
          :to="withRouteParams({ name: 'country-index' })"
          @click="onClick"
        />
      </div>
    </BaseMain>
    <AppFooter />
  </v-app>
</template>

<script setup lang="ts">
import { useWindowSize } from '@vueuse/core'

const props = defineProps({
  error: { type: Object, default: () => ({}) },
})

const route = useRoute()
const { width } = useWindowSize()

if (import.meta.env.DEV) {
  // eslint-disable-next-line
  console.error(props.error)
}

const content = computed(() => ({
  title: props.error?.statusCode === 404 ? 'На этой странице ничего нет' : 'Что-то пошло не так',
  subtitle: props.error?.statusCode === 404
    ? 'Возможно, материал удалили или перенесли на другую страницу. Или вы перешли по ссылке, в которой была ошибка'
    : 'Попробуйте немного подождать и обновить страницу',
  img: props.error?.statusCode === 404 ? '/errors/404.png' : '/errors/500.svg',
  imgSize: width.value > 500 && props.error?.statusCode === 404 ? 250 : 175,
}))

function onClick() {
  if (route.name === 'country-index') {
    location.reload()
  }
}
</script>

<style lang="scss" scoped>
.error-page {
  height: 100vh;

  &__content {
    max-width: 552px;
  }
}
</style>
